import {Avatar, DatePicker, Image, Input, Radio} from 'antd'
import {getId} from 'apis/model/base'
import {ROOT_URL} from 'envs/_current/config'
import _ from 'lodash'
import {useAppConfig} from 'modules/local/AppConfigContext'
import useTranslate from 'modules/local/useTranslate'
import withTranslate from 'modules/local/withTranslate'
import React, {useContext} from 'react'
import {compose, mapProps, nest, pure, withProps} from 'recompose'
import {PhotoUploadComposite} from 'views/AppLocals/custom/PhotoField'
import SelectDataSource from 'views/AppLocals/custom/SelectDataSource'
import {AppEntities} from 'views/AppLocals/enums'
import {createControlledFormField} from 'views/AppLocals/factory/createFormField'
import OrganizationContainerContext from 'views/AppLocals/Organization/OrganizationContainerContext'
import Translate from "../../../../modules/local/Translate";
import {deepTranslate, renderIf, renderIfElse, shallowDiff} from "../../../Shared";
import TooltipApp from "components/TooltipApp";
import {appClassNames} from "../../custom/appClassNames";
import {LayoutContext} from "../../../../components/layouts/Default/LayoutContext";
import LookupField from "../../../../components/LookupField";
import {RiMapPinFill} from "react-icons/ri";
import {MdChurch} from "react-icons/md";
import classNames from "classnames";
import {IoCalendarOutline, IoPeople, IoPerson} from "react-icons/io5";
import {BsGlobeCentralSouthAsia, BsPersonCircle} from "react-icons/bs";
import {PartialEditGroupWrapper} from "../../../../components/form/PartialEditForm";
import {useOrganizationApi} from "../functions/useOrganizationApi";
import {ItemInformation} from 'components/common/ItemInformation'
import {OrgType} from "../components/OrgType";
import {convertFromString} from "../../../SlateEditor/functions";
import {HiViewfinderCircle} from "react-icons/hi2";
import {PhotoPlaceholderApp} from "../../../../conts/imageBase64";
import {BiSolidChurch} from "react-icons/bi";
import {createSelectValue, createValue} from "../../../../components/form/utils";
import dayjs from "dayjs";
import {SaintsOutlineSvg} from "../../../../components/Svgs/SaintsPlaceholder";
import {DoubleValueItem} from 'components/common/DoubleValueItem'
import {joinPolicyOptions, privacyOptions} from "../../../../conts/privacyOptions";
import {SelectWidget} from "../../custom/ReactSelectComponents";
import {
    firstLetterUppercase,
    lengthBetween,
    noDoubleSpaces,
    noLeadingTrailingSpaces,
    noNumber,
    noSpecialChars,
    required,
    runRules
} from "../../../../components/form/ValidateForm";

const formFields = [
    {name: 'title'},
    {name: 'idname'},
    {name: 'avatar'},
    {name: 'patron_saint_id'},
    {name: 'patron_saint_name'},
    {name: 'patron_saint_feast_day'},
    {name: 'org_type'},
    {name: 'org_types'},
    {name: 'description'},
    {name: 'diocese_location'},
    {name: 'archdiocese'},
    {name: 'diocese'},
    {name: 'diocese_name'},
    {name: 'deanery'},
    {name: 'parish'},
    {name: 'parish_name'},
    {name: 'cover_photo'},
    {name: 'avatar_preview'},
    {name: 'cover_photo_preview'},
    {name: 'privacy', defaultValue: 1},
    {name: 'join_policy', defaultValue: 1},
    {name: 'public', defaultValue: 1},
]

const formSchema = [
    {
        children: [
            {
                name: 'avatar',
                component: mapProps(({form, onChange}) => {
                    const values = _.get(form, 'values')
                    return {
                        values,
                        onChange,
                        title: _.get(values, 'title'),
                        fallback_cover: undefined,
                    }
                })(PhotoUploadComposite),
            },
        ],
    },
    {
        title: 'organization type',
        children: [
            {
                name: 'org_type',
                component: createControlledFormField({
                    Component: SelectDataSource,
                    placeholder: 'Select...',
                    withValues: (values) => ({
                        dataSource: _.get(values, 'org_types'),
                        defaultValue: _.get(values, 'org_type'),
                    }),
                }),
            },
        ],
    },
    {
        inline: true,
        className: appClassNames.inline_2,
        children: [
            {
                label: 'belong to parish',
                name: 'parish',
                component: ({name, value, onChange, form, ...restForm}) => {
                    return (
                        <LayoutContext.Consumer>
                            {({isSm}) => (
                                <Translate>
                                    {(t) => (
                                        <LookupField
                                            title={t('choose parish')}
                                            createIfNotExists={true}
                                            defaultValue={form?.values?.parish_name}
                                            selectedOption={form?.values?.parish}
                                            placeholder={t('click to select / create')}
                                            apiPath={`/lookup/parish/get-by-types`}
                                            name={name}
                                            OptionWrapper={({children, ...props}) =>
                                                <div
                                                    className="flex items-center gap-2 border border-color-50 hover:shadow-md rounded-lg relative" {...props}>
                                                    {children}
                                                </div>
                                            }
                                            renderOption={(o, i) => {
                                                const {fullname, diocese_fullname, location_address} = o ?? {}
                                                return (
                                                    <div key={i} className="flex items-center flex-1 gap-3">
                                                        {renderIf(
                                                            !isSm,
                                                            <Avatar
                                                                size={50}
                                                                src={o.avatar}
                                                                className="flex flex-center background-200 rounded-l-lg rounded-r-0"
                                                                icon={<MdChurch size={20} style={{color: '#dddddd'}}/>}
                                                            />
                                                        )}
                                                        <div className="py-2 md:py-0 flex flex-col flex-1 min-w-0 gap-1">
                                                            <div className="space-x-1 leading-snug">
                                                                <span className="font-bold text-sm text-color-000">
                                                                    {fullname}
                                                                </span>
                                                                <span
                                                                    className="font-medium text-xs text-blue-500 italic leading-snug">
                                                                    {`( ${diocese_fullname} )`}
                                                                </span>
                                                            </div>
                                                            {renderIf(
                                                                location_address,
                                                                <div className="flex items-center gap-x-1">
                                                                    <RiMapPinFill size={11} className="text-color-400"/>
                                                                    <span
                                                                        className="flex-1 max-lines-1 text-xs text-color-400 italic leading-snug">
                                                                        {location_address}
                                                                    </span>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                )
                                            }}
                                            handleChange={(e) => {
                                                form.setValues({
                                                    ...form.values,
                                                    parish: e.target,
                                                    parish_name: e.target.value,
                                                    parish_id: e.target.id,
                                                    diocese: e.target.diocese,
                                                    diocese_name: e.target?.diocese?.name,
                                                    diocese_id: e.target?.diocese?.id
                                                });
                                            }}
                                        />
                                    )}
                                </Translate>
                            )}
                        </LayoutContext.Consumer>
                    )
                },
            },
            {
                label: 'diocese',
                name: 'diocese',
                component: ({name, value, onChange, form, ...restForm}) => {
                    return (
                        <LayoutContext.Consumer>
                            {({isSm}) => (
                                <Translate>
                                    {(t) => (
                                        <LookupField
                                            title={t('choose diocese')}
                                            createIfNotExists={true}
                                            defaultValue={form?.values?.diocese_name}
                                            selectedOption={form?.values?.diocese}
                                            apiPath={`/lookup/diocese/get-by-types`}
                                            name={name}
                                            OptionWrapper={({children, ...props}) =>
                                                <div
                                                    className="flex items-center gap-2 border border-color-50 hover:shadow-md rounded-lg relative" {...props}>
                                                    {children}
                                                </div>
                                            }
                                            renderOption={(o, i) => {
                                                const {fullname, location_address} = o ?? {}
                                                return (
                                                    <div key={i} className="flex items-center flex-1 gap-3">
                                                        <Avatar
                                                            size={50}
                                                            src={o.avatar}
                                                            className="flex flex-center background-200 rounded-l-lg rounded-r-0"
                                                            icon={<MdChurch size={20} style={{color: '#dddddd'}}/>}
                                                        />
                                                        <div className="py-2 md:py-0 flex flex-col flex-1 min-w-0 gap-1">
                                                            <div className="space-x-1 leading-snug">
                                                              <span className="font-bold text-sm text-color-000">
                                                                  {fullname}
                                                              </span>
                                                            </div>
                                                            {renderIf(
                                                                location_address,
                                                                <div className="flex items-center gap-x-1">
                                                                    <RiMapPinFill size={11} className="text-color-400"/>
                                                                    <span
                                                                        className="flex-1 max-lines-1 text-xs text-color-400 italic leading-snug">
                                                                    {location_address}
                                                                  </span>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                )
                                            }}
                                            handleChange={(e) => {
                                                form.setValues({
                                                    ...form.values,
                                                    diocese: e.target,
                                                    diocese_name: e.target?.value,
                                                    diocese_id: e.target?.id
                                                });
                                            }}
                                        />
                                    )}
                                </Translate>
                            )}
                        </LayoutContext.Consumer>
                    )
                },
            },
        ],
    },
    {
        title: 'title',
        children: [
            {
                name: 'title',
                component: compose(
                    withTranslate,
                    mapProps(({name, onChange, value, translate}) => ({
                        name,
                        value,
                        onChange,
                        maxLength: 160,
                        showCount: true,
                        style: {borderRadius: '0.375rem'},
                        placeholder: translate('name of your company'),
                    }))
                )(Input),
            },
        ],
    },
    {
        title: 'description',
        children: {
            name: 'description',
            component: createControlledFormField({
                Component: Input.TextArea,
                rows: 5,
                placeholder: 'Short description about your organization!',
            }),
        },
    },

    {
        inline: true,
        className: 'grid grid-cols-1 md:grid-cols-2 gap-3',
        children: [
            {
                label: 'holy name',
                name: 'patron_saint',
                component: ({name, value, onChange, form, ...restForm}) => {
                    return (
                        <Translate>
                            {(t) => (
                                <LookupField
                                    createIfNotExists={true}
                                    defaultValue={form?.values?.patron_saint_name}
                                    selectedOption={form?.values?.patron_saint}
                                    apiPath={`/lookup/saint/get-by-types`}
                                    name={name}
                                    OptionWrapper={({children, ...props}) =>
                                        <div
                                            className="flex items-center gap-2 border border-color-50 hover:shadow-md rounded-lg relative" {...props}>
                                            {children}
                                        </div>
                                    }
                                    renderOption={(o, i) => {
                                        return (
                                            <div key={i} className="flex items-center flex-1 gap-3">
                                                <Avatar
                                                    size={60}
                                                    src={o.avatar}
                                                    className="flex flex-center background-200 rounded-l-lg rounded-r-0"
                                                    icon={<SaintsOutlineSvg size={30} style={{color: '#dddddd'}}/>}
                                                />
                                                <div className="flex flex-col flex-1 max-lines-3">
                                                            <span
                                                                className="font-bold text-sm text-color-000 leading-tight">
                                                    {`${o.common_name || o.name} (${o.patron_saint_feast_day || o.feast_day})`}
                                                            </span>
                                                    {renderIf(
                                                        o?.description,
                                                        <div className="flex items-center">
                                                                <span
                                                                    className="text-xs text-color-400 italic max-lines-2 leading-snug">{o?.description}</span>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        )
                                    }}
                                    handleChange={(e) => {
                                        form.setValues({
                                            ...form.values,
                                            patron_saint: e.target,
                                            patron_saint_name: e.target.common_name || e.target.value,
                                            patron_saint_feast_day: e.target.feast_day,
                                            patron_saint_id: e.target.id
                                        });
                                    }}
                                />
                            )}
                        </Translate>
                    )
                },
            },
            {
                label: 'patron saint feast day',
                name: 'patron_saint_feast_day',
                component: compose(
                    withTranslate,
                    withProps(({value, onChange, translate}) => ({
                        onChange: (date, dateString) => {
                            onChange(createValue('patron_saint_feast_day', dateString))
                        },
                        value: !!value ? dayjs(value, "DD/MM") : null,
                        className: 'w-full',
                        suffixIcon: <IoCalendarOutline className="text-color-500"/>,
                        name: 'patron saint feast day',
                        placeholder: translate('patron saint feast day'),
                        format: 'DD/MM'
                    }))
                )(DatePicker),
            },
        ],
    },

    {
        title: 'url',
        invisible: true,
        children: {
            name: 'idname',
            component: compose(
                mapProps(({name, value}) => ({
                    name,
                    value,
                    addonBefore: [ROOT_URL, AppEntities.ORGANIZATION].join('/'),
                    placeholder: 'please input name!',
                    trigger: ['focus'],
                    placement: 'topLeft',
                    title: [ROOT_URL, AppEntities.ORGANIZATION, value].join('/'),
                })),
                pure
            )(nest(TooltipApp, Input)),
        },
    },
    {
        title: 'privacy',
        children: [
            {
                name: 'privacy',
                component: compose(
                    withProps({
                        buttonStyle: 'solid',
                        name: 'privacy',
                    })
                )((props) => {
                    const t = useTranslate()
                    const options = [
                        {
                            icon: <BsGlobeCentralSouthAsia size={16}/>,
                            value: 1,
                            label: 'public',
                            description: 'This content is available to everyone.',
                        },
                        {
                            icon: <BsPersonCircle size={16}/>,
                            value: 2,
                            label: 'private',
                            description: 'This content is available to members only.',
                        },
                    ]
                    return (
                        <div className="flex flex-col gap-2">
                            <Radio.Group className="custom-radio-button" {...props}>
                                {options.map((e, i) => (
                                    <React.Fragment key={e?.value}>
                                        <Radio.Button value={e?.value}>{t(e?.label)}</Radio.Button>
                                    </React.Fragment>
                                ))}
                            </Radio.Group>
                            <div className="rounded-lg">
                                {options.map((e, i) => (
                                    <div
                                        key={i}
                                        className={classNames(
                                            'p-2 flex flex-col gap-1',
                                            e?.value === 1 ? 'rounded-t-lg' : 'rounded-b-lg border',
                                            e?.value === props.value ? 'border border-primary' : 'border'
                                        )}>
                                        <div
                                            className={classNames("flex items-center gap-2", e?.value === props.value ? 'text-primary' : 'text-color-100')}>
                                            {e?.icon}
                                            <span className="font-bold italic tracking-wide">
                                                {t(e?.label)}
                                            </span>
                                        </div>
                                        <div
                                            className={classNames(
                                                'ml-6 text-sm tracking-wider leading-snug',
                                                e?.value === props.value ? 'text-primary-500' : 'text-color-400'
                                            )}>
                                            {t(e?.description)}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )
                }),
            },
        ],
    },
    {
        title: 'general access',
        children: [
            {
                name: 'public',
                component: compose(
                    withProps({
                        buttonStyle: 'solid',
                        name: 'public',
                    })
                )((props) => {
                    const t = useTranslate()
                    const options = [
                        {
                            icon: <IoPeople size={16}/>,
                            value: 1,
                            label: 'everyone',
                            description: 'This content is publicly visible and can appear in searches or public listings.',
                        },
                        {
                            icon: <IoPerson size={16}/>,
                            value: 0,
                            label: 'restricted',
                            description: 'Only people with the direct link can access this content. It will not appear in searches or public listings.',
                        },
                    ]
                    return (
                        <div className="flex flex-col gap-2">
                            <Radio.Group className="custom-radio-button" {...props}>
                                {options.map((e, i) => (
                                    <React.Fragment key={e?.value}>
                                        <Radio.Button value={e?.value}>{t(e?.label)}</Radio.Button>
                                    </React.Fragment>
                                ))}
                            </Radio.Group>
                            <div className="rounded-xl">
                                {options.map((e, i) => (
                                    <div
                                        key={i}
                                        className={classNames(
                                            'p-2 flex flex-col gap-1',
                                            e?.value === 1 ? 'rounded-t-lg' : 'rounded-b-lg border',
                                            e?.value === props.value ? 'border border-secondary' : 'border'
                                        )}>
                                        <div
                                            className={classNames("flex items-center gap-2", e?.value === props.value ? 'text-secondary-600' : 'text-color-100')}>
                                            {e?.icon}
                                            <span className="font-bold italic tracking-wide">
                                                {t(e?.label)}
                                            </span>
                                        </div>
                                        <div
                                            className={classNames(
                                                'ml-6 text-sm tracking-wider leading-snug',
                                                e?.value === props.value ? 'text-secondary' : 'text-color-400'
                                            )}>
                                            {t(e?.description)}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )
                }),
            },
        ],
    }
]

const groupFields = {
    avatar_photo: {
        title: 'avatar & cover photo',
        render: (item) => {
            const {avatar, cover_photo} = item ?? {}

            return (
                <div className="relative">
                    <Image
                        fallback={PhotoPlaceholderApp}
                        src={cover_photo}
                        style={{height: 200, maxHeight: 200}}
                        className="rounded-lg object-cover"
                        wrapperClassName="w-full rounded-lg"
                        preview={{
                            mask: (
                                <div className="w-full h-full relative">
                                    <HiViewfinderCircle
                                        size={16}
                                        style={{top: 10, right: 10}}
                                        className="absolute text-white opacity-85 hover:opacity-100 custom-img-view-icon"
                                    />
                                </div>
                            ),
                        }}
                    />
                    <Avatar
                        size={80}
                        src={avatar}
                        icon={<BiSolidChurch size={40} className="text-color-500"/>}
                        className="flex flex-center background-50 border-2 border-white shadow-items rounded-lg absolute left-10 bottom-10"
                    />
                </div>
            )
        },
        formSchemas: [
            {
                children: [
                    {
                        name: 'avatar',
                        component: mapProps(({form, onChange}) => {
                            const values = _.get(form, 'values')
                            return {
                                values,
                                onChange,
                                title: _.get(values, 'title'),
                                fallback_cover: undefined,
                            }
                        })(PhotoUploadComposite),
                    },
                ],
            },
        ],
        onValidate: (values, t) => {

            let errors = {}

            return errors
        },
    },
    organizationInformation: {
        title: 'organization info',
        render: (item) => {
            const {title, parish_name, diocese, patron_saint_name, patron_saint_feast_day} = item ?? {}

            return (
                <Translate>
                    {(t) => (
                        <div className="flex flex-col gap-2">
                            <div className="font-bold text-base text-primary tracking-wide">
                                {title}
                            </div>
                            <ItemInformation label="organization type" value={<OrgType item={item}/>}
                                             className="tracking-wider"/>
                            <DoubleValueItem
                                labelFirst="belong to parish"
                                valueFirst={parish_name}
                                labelSecond={diocese?.fullname && " - " || ''}
                                valueSecond={diocese?.fullname}
                                className="tracking-wider"
                            />
                            <ItemInformation label="patron saint" value={patron_saint_name} className="tracking-wider"/>
                            <ItemInformation label="feast day" value={patron_saint_feast_day} className="tracking-wider"/>
                        </div>
                    )}
                </Translate>
            )
        },
        formSchemas: [
            {
                title: 'organization type',
                children: [
                    {
                        name: 'org_type',
                        component: createControlledFormField({
                            Component: SelectDataSource,
                            placeholder: 'Select...',
                            withValues: (values) => ({
                                dataSource: _.get(values, 'org_types'),
                                defaultValue: _.get(values, 'org_type'),
                            }),
                        }),
                    },
                ],
            },
            {
                title: 'title',
                children: [
                    {
                        name: 'title',
                        component: compose(
                            withTranslate,
                            mapProps(({name, onChange, value, translate}) => ({
                                name,
                                value,
                                onChange,
                                maxLength: 160,
                                showCount: true,
                                style: {borderRadius: '0.375rem'},
                                placeholder: translate('name of your company'),
                            }))
                        )(Input),
                    },
                ],
            },
            {
                title: 'url',
                children: [
                    {
                        name: 'idname',
                        component: compose(
                            mapProps(({onChange, value}) => ({
                                onChange,
                                value,
                                name: 'idname',
                                addonBefore: 'https://.../organization/',
                                placeholder: 'please input name!',
                                type: 'text',
                                trigger: ['focus'],
                                title: ROOT_URL + '/organization/' + value,
                                placement: 'topLeft',
                            })),
                            pure
                        )(nest(TooltipApp, Input)),
                    },
                ]
            },
            {
                inline: true,
                className: appClassNames.inline_2,
                children: [
                    {
                        label: 'belong to parish',
                        name: 'parish',
                        component: ({name, value, onChange, form, ...restForm}) => {
                            return (
                                <LayoutContext.Consumer>
                                    {({isSm}) => (
                                        <Translate>
                                            {(t) => (
                                                <LookupField
                                                    title={t('choose parish')}
                                                    createIfNotExists={true}
                                                    defaultValue={form?.values?.parish_name}
                                                    selectedOption={form?.values?.parish}
                                                    placeholder={t('click to select / create')}
                                                    apiPath={`/lookup/parish/get-by-types`}
                                                    name={name}
                                                    OptionWrapper={({children, ...props}) =>
                                                        <div
                                                            className="flex items-center gap-2 border border-color-50 hover:shadow-md rounded-lg relative" {...props}>
                                                            {children}
                                                        </div>
                                                    }
                                                    renderOption={(o, i) => {
                                                        const {fullname, diocese_fullname, location_address} = o ?? {}
                                                        return (
                                                            <div key={i} className="flex items-center flex-1 gap-3">
                                                                {renderIf(
                                                                    !isSm,
                                                                    <Avatar
                                                                        size={50}
                                                                        src={o.avatar}
                                                                        className="flex flex-center background-200 rounded-l-lg rounded-r-0"
                                                                        icon={<MdChurch size={20}
                                                                                        style={{color: '#dddddd'}}/>}
                                                                    />
                                                                )}
                                                                <div
                                                                    className="py-2 md:py-0 flex flex-col flex-1 gap-1">
                                                                    <div className="space-x-1 leading-snug">
                                                                <span className="font-bold text-sm text-color-000">
                                                                    {fullname}
                                                                </span>
                                                                        <span
                                                                            className="font-medium text-xs text-blue-500 italic leading-snug">
                                                                    {`( ${diocese_fullname} )`}
                                                                </span>
                                                                    </div>
                                                                    {renderIf(
                                                                        location_address,
                                                                        <div className="flex items-center gap-x-1">
                                                                            <RiMapPinFill size={11}
                                                                                          className="text-color-400"/>
                                                                            <span
                                                                                className="flex-1 max-lines-1 text-xs text-color-400 italic leading-snug">
                                                                        {location_address}
                                                                    </span>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        )
                                                    }}
                                                    handleChange={(e) => {
                                                        form.setValues({
                                                            ...form.values,
                                                            parish: e.target,
                                                            parish_name: e.target.value,
                                                            parish_id: e.target.id,
                                                            diocese: e.target.diocese,
                                                            diocese_name: e.target?.diocese?.name,
                                                            diocese_id: e.target?.diocese?.id
                                                        });
                                                    }}
                                                />
                                            )}
                                        </Translate>
                                    )}
                                </LayoutContext.Consumer>
                            )
                        },
                    },
                    {
                        label: 'diocese',
                        name: 'diocese',
                        component: ({name, value, onChange, form, ...restForm}) => {
                            return (
                                <Translate>
                                    {(t) => (
                                        <LookupField
                                            title={t('choose diocese')}
                                            createIfNotExists={true}
                                            defaultValue={form?.values?.diocese_name}
                                            selectedOption={form?.values?.diocese}
                                            apiPath={`/lookup/diocese/get-by-types`}
                                            name={name}
                                            OptionWrapper={({children, ...props}) =>
                                                <div
                                                    className="flex items-center gap-2 border border-color-50 hover:shadow-md rounded-lg relative" {...props}>
                                                    {children}
                                                </div>
                                            }
                                            renderOption={(o, i) => {
                                                const {fullname, location_address} = o ?? {}
                                                return (
                                                    <div key={i} className="flex items-center flex-1 gap-3">
                                                        <Avatar
                                                            size={50}
                                                            src={o.avatar}
                                                            className="flex flex-center background-200 rounded-l-lg rounded-r-0"
                                                            icon={<MdChurch size={20} style={{color: '#dddddd'}}/>}
                                                        />
                                                        <div className="py-2 md:py-0 flex flex-col flex-1 min-w-0 gap-1">
                                                            <div className="space-x-1 leading-snug">
                                                              <span className="font-bold text-sm text-color-000">
                                                                  {fullname}
                                                              </span>
                                                            </div>
                                                            {renderIf(
                                                                location_address,
                                                                <div className="flex items-center gap-x-1">
                                                                    <RiMapPinFill size={11} className="text-color-400"/>
                                                                    <span
                                                                        className="flex-1 max-lines-1 text-xs text-color-400 italic leading-snug">
                                                                    {location_address}
                                                                  </span>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                )
                                            }}
                                            handleChange={(e) => {
                                                form.setValues({
                                                    ...form.values,
                                                    diocese: e.target,
                                                    diocese_name: e.target?.value,
                                                    diocese_id: e.target?.id
                                                });
                                            }}
                                        />
                                    )}
                                </Translate>
                            )
                        },
                    },
                ],
            },
            {
                inline: true,
                className: 'grid grid-cols-1 md:grid-cols-2 gap-3',
                children: [
                    {
                        label: 'holy name',
                        name: 'patron_saint',
                        component: ({name, value, onChange, form, ...restForm}) => {
                            return (
                                <Translate>
                                    {(t) => (
                                        <LookupField
                                            createIfNotExists={true}
                                            defaultValue={form?.values?.patron_saint_name}
                                            selectedOption={form?.values?.patron_saint}
                                            apiPath={`/lookup/saint/get-by-types`}
                                            name={name}
                                            OptionWrapper={({children, ...props}) =>
                                                <div
                                                    className="flex items-center gap-2 border border-color-50 hover:shadow-md rounded-lg relative" {...props}>
                                                    {children}
                                                </div>
                                            }
                                            renderOption={(o, i) => {
                                                return (
                                                    <div key={i} className="flex items-center flex-1 gap-3">
                                                        <Avatar
                                                            size={60}
                                                            src={o.avatar}
                                                            className="flex flex-center background-200 rounded-l-lg rounded-r-0"
                                                            icon={<SaintsOutlineSvg size={30}
                                                                                    style={{color: '#dddddd'}}/>}
                                                        />
                                                        <div className="flex flex-col flex-1 max-lines-3">
                                                            <span
                                                                className="font-bold text-sm text-color-000 leading-tight">
                                                    {`${o.common_name || o.name} (${o.patron_saint_feast_day || o.feast_day})`}
                                                            </span>
                                                            {renderIf(
                                                                o?.description,
                                                                <div className="flex items-center">
                                                                <span
                                                                    className="text-xs text-color-400 italic max-lines-2 leading-snug">{o?.description}</span>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                )
                                            }}
                                            handleChange={(e) => {
                                                form.setValues({
                                                    ...form.values,
                                                    patron_saint: e.target,
                                                    patron_saint_name: e.target.common_name || e.target.value,
                                                    patron_saint_feast_day: e.target.feast_day,
                                                    patron_saint_id: e.target.id
                                                });
                                            }}
                                        />
                                    )}
                                </Translate>
                            )
                        },
                    },
                    {
                        label: 'patron saint feast day',
                        name: 'patron_saint_feast_day',
                        component: compose(
                            withTranslate,
                            withProps(({value, onChange, translate}) => ({
                                onChange: (date, dateString) => {
                                    onChange(createValue('patron_saint_feast_day', dateString))
                                },
                                value: !!value ? dayjs(value, "DD/MM") : null,
                                className: 'w-full',
                                suffixIcon: <IoCalendarOutline className="text-color-500"/>,
                                name: 'patron saint feast day',
                                placeholder: translate('patron saint feast day'),
                                format: 'DD/MM'
                            }))
                        )(DatePicker),
                    },
                ],
            },
        ],
        onValidate: (values, t) => {

            const {
                org_type,
                title,
                idname,
                parish,
                diocese,
                patron_saint,
                patron_saint_feast_day
            } = values ?? {}

            const validateTitleOrParishOrDiocese = (value, keyName, t) => {
                const maxLengthConfig = {
                    title: 160,
                    parish: 120,
                    diocese: 120,
                    patron_saint: 180
                }
                if(!value && keyName !== 'title') return {};
                const rules = [
                    keyName === 'title' ? required(t) : null,
                    lengthBetween(1, maxLengthConfig[keyName], t),
                    noNumber(t),
                    noSpecialChars(t),
                    noLeadingTrailingSpaces(t),
                    noDoubleSpaces(t),
                    firstLetterUppercase(t),
                ].filter(Boolean)
                const message = runRules(value, rules)
                if (message) return {[keyName]: message}
            }

            const validateIdName = (value, t) => {
                if(!value) return {idname: t('required')}
            }

            const errorTitle = validateTitleOrParishOrDiocese(title, 'title', t)
            const errorParish = validateTitleOrParishOrDiocese(parish ? (parish.value ?? '') : '', 'parish', t)
            const errorDiocese = validateTitleOrParishOrDiocese(diocese ? (diocese.value ?? '') : '', 'diocese', t)
            const errorPatronSaint = validateTitleOrParishOrDiocese(patron_saint ? (patron_saint.value ?? '') : '', 'patron_saint', t)
            const errorIdName = validateIdName(idname, t)

            return {
                ...errorIdName,
                ...errorTitle,
                ...errorParish,
                ...errorDiocese,
                ...errorPatronSaint,
            }
        },
    },
    description: {
        title: 'short description - charism & mission',
        render: (item) => {
            const {description,} = item ?? {}

            return (
                <Translate>
                    {(t) => (
                        <div className="flex flex-col gap-2">
                            {renderIfElse(
                                description,
                                <div className="text-color-200 tracking-wider whitespace-pre-line">
                                    {description}
                                </div>,
                                <span className="text-color-400 tracking-wide italic">
                                    {`${t('no data is available now')}...`}
                                </span>
                            )}
                        </div>
                    )}
                </Translate>
            )
        },
        formSchemas: [
            {
                title: 'short description - charism & mission',
                children: [
                    {
                        name: 'description',
                        component: createControlledFormField({
                            showCount: true,
                            maxLength: 500,
                            Component: Input.TextArea,
                            rows: 5,
                            placeholder: 'Short description about your organization!',
                        }),
                    },
                ],
            },
            // {
            //     title: 'url',
            //     children: [
            //         {
            //             name: 'idname',
            //             component: compose(
            //                 mapProps(({name, value}) => ({
            //                     name,
            //                     value,
            //                     addonBefore: [ROOT_URL, AppEntities.ORGANIZATION].join('/'),
            //                     placeholder: 'please input name!',
            //                     trigger: ['focus'],
            //                     placement: 'topLeft',
            //                     disabled: true,
            //                     title: [ROOT_URL, AppEntities.ORGANIZATION, value].join('/'),
            //                 })),
            //                 pure
            //             )(nest(TooltipApp, Input)),
            //         },
            //     ],
            // },
        ],
        onValidate: (values, t) => {

            let errors = {}

            return errors
        },
    },
    privacyAccess: {
        title: 'privacy & access',
        render: (item) => {
            const {privacy, join_policy} = item ?? {}

            return (
                <Translate>
                    {(t) => (
                        <div className="flex flex-col gap-2">
                            <ItemInformation
                                showIcon={true}
                                label="privacy" value={t(privacyOptions[privacy]?.label) ?? t('unknown')}
                                className="italic tracking-wider"
                            />
                            <ItemInformation
                                showIcon={true}
                                label="join policy" value={t(joinPolicyOptions[join_policy]?.label) ?? t('unknown')}
                                className="italic tracking-wider"
                            />
                            <ItemInformation
                                showIcon={true}
                                label="general access"
                                value={_.get(item, 'public') === 1 ? t('everyone') : t('restricted')}
                                className="italic tracking-wider"
                            />
                        </div>
                    )}
                </Translate>
            )
        },
        formSchemas: [
            {
                children: [
                    {
                        label: 'privacy',
                        name: 'privacy',
                        component: compose(withTranslate)(({name, translate: t, onChange, value}) => {
                            const desc = {
                                1: t('Content, posts and activities of the organization are publicly visible to all.'),
                                2: t('Content is only visible to accepted members of the organization.'),
                            }
                            return (
                                <div className="flex flex-col gap-1">
                                    <SelectWidget
                                        name={name}
                                        className="w-full"
                                        value={value || undefined}
                                        onChange={(v) => onChange(createSelectValue('privacy', v))}
                                        placeholder={t('---Choose One---')}
                                        options={Object.values(privacyOptions).map(deepTranslate(t))}
                                    />
                                    {desc[value] && (
                                        <p className="text-xs text-color-400 italic leading-relaxed tracking-wide">
                                            {desc[value]}
                                        </p>
                                    )}
                                </div>
                            )
                        }),
                    },
                    {
                        label: 'join policy',
                        name: 'join_policy',
                        component: compose(withTranslate)(({name, translate: t, onChange, value}) => {
                            const desc = {
                                1: t('Anyone can freely join the organization immediately.'),
                                2: t('Users submit a join request — admins review and approve before granting access.'),
                                3: t('Only admins can actively invite or add members to the organization.'),
                            }
                            return (
                                <div className="flex flex-col gap-1">
                                    <SelectWidget
                                        name={name}
                                        className="w-full"
                                        value={value || undefined}
                                        onChange={(v) => onChange(createSelectValue('join_policy', v))}
                                        placeholder={t('---Choose One---')}
                                        options={Object.values(joinPolicyOptions).map(deepTranslate(t))}
                                    />
                                    {desc[value] && (
                                        <p className="text-xs text-color-400 italic leading-relaxed tracking-wide">
                                            {desc[value]}
                                        </p>
                                    )}
                                </div>
                            )
                        }),
                    },
                    {
                        label: 'general access',
                        name: 'public',
                        component: compose(withTranslate)(({name, translate: t, onChange, value}) => {
                            const publicOpts = [
                                {value: 1, label: t('Public – visible in search')},
                                {value: 0, label: t('Restricted – link only')},
                            ]
                            const desc = {
                                1: t('The organization appears in search results and public listings — anyone can find it.'),
                                0: t('The organization does not appear in search. Only accessible via direct link.'),
                            }
                            return (
                                <div className="flex flex-col gap-1">
                                    <SelectWidget
                                        name={name}
                                        className="w-full"
                                        value={value !== undefined ? value : undefined}
                                        onChange={(v) => onChange(createSelectValue('public', v))}
                                        placeholder={t('---Choose One---')}
                                        options={publicOpts}
                                    />
                                    {desc[value] !== undefined && (
                                        <p className="text-xs text-color-400 italic leading-relaxed tracking-wide">
                                            {desc[value]}
                                        </p>
                                    )}
                                </div>
                            )
                        }),
                    },
                ],
            },
        ],
        onValidate: (values, t) => {

            let errors = {}

            return errors
        },
    }
}

const OrganizationSettingOverview = () => {
    const t = useTranslate()

    const {org_types: org_type_options = {}} = useAppConfig('org_types')

    const {organization} = useContext(OrganizationContainerContext)

    const id = getId(organization)

    const org_types = Object.keys(org_type_options).map((name) => ({
        value: Number(name),
        label: org_type_options[name],
    }))

    const initialValues = {
        ...organization,
        org_types,
        avatar_preview: organization?.avatar,
        avatar: organization?.avatar,
        cover_photo_preview: organization?.cover_photo,
        cover_photo: organization?.cover_photo,
        about: convertFromString(organization?.about),
        public: organization?.public,
        parish_id: _.get(organization, 'parish.id', ''),
        parish_name: _.get(organization, 'parish_name', ''),
        parish: _.get(organization, 'parish'),
        diocese_id: _.get(organization, 'diocese.id', ''),
        diocese_name: _.get(organization, 'diocese_name', ''),
        diocese: _.get(organization, 'diocese'),
        org_type: organization?.org_type ? Number(organization?.org_type) : undefined,
        patron_saint_id: _.get(organization, 'patron_saint.id', ''),
    }

    const {onUpdate} = useOrganizationApi({})

    if (_.isEmpty(organization)) return null

    return (
        <div className="flex flex-col gap-3">
            <PartialEditGroupWrapper
                groupFields={[
                    groupFields.avatar_photo,
                    groupFields.organizationInformation,
                    groupFields.description,
                    groupFields.privacyAccess,
                ]}
                initialValues={initialValues}
                item={initialValues}
                onSubmit={({...values}) => {
                    const {...changes} = shallowDiff(values, initialValues)
                    onUpdate(
                        _.omitBy({...changes,}, _.isUndefined),
                        {id: id}
                    )
                }}
            />
        </div>
    )

}

export default OrganizationSettingOverview
